export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_9a2dc31b-00c4-45d0-ad69-0565da0dad3b/artifacts/vop5ou8y_Firefly_Gemini%20Flash%20%2813%29.png";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
